import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import styles from "../../styles/modules/ProjectSummary.module.scss";
import { Redirect } from "react-router-dom";
import DialogEmailQuote from "../ProjectQuote/DialogEmailQuote/DialogEmailQuote";
import DialogEmailSpecList from "../ProjectQuote/DialogEmailSpecList/DialogEmailSpecList";
import DialogEmailPictureBook from "../ProjectQuote/DialogEmailPictureBook/DialogEmailPictureBook";
import PrintForm from "../ProjectQuote/PrintForm/PrintForm";
import * as actionTypes from "../../store/actions";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";
import checkSettings from "../../utils/checkSettings";

class ProjectSummary extends Component {
	state = {
		loaded: 0,
		error: "",
		redirect: "",
		client: {},
		project: {},
		quote: {},
		products: {}
	};

	componentDidMount = async () => {
		let project_id = parseInt(this.props.match.params.id);
		if (!project_id) {
			this.setState({ redirect: "/search-projects" });
			return;
		}
		let route = "/projects/fetch-summary";
		let response = await Axios.post(this.props.APIUrl + route, { project_id: project_id });

		let stateChanges = { loaded: 1 };

		if (response.data.hasOwnProperty("error")) {
			stateChanges.error = response.data.error;
		} else if (response.data.hasOwnProperty("norecord")) {
			stateChanges.redirect = "/project?projectId=" + project_id;
		} else {
			stateChanges.client = response.data.customer;
			stateChanges.project = response.data.project;
			stateChanges.quote = response.data.quote;
			stateChanges.products = response.data.products;

			this.props.saveProjectId(project_id);
		}
		this.setState(stateChanges);
	};

	formatDate = date => {
		if (!date) return "";
		let newDate = new Date(date);
		let day = newDate.getDate();
		let month = 1 + newDate.getMonth();
		return newDate.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
	};

	renderProductTable = products => {
		return (
			<table className={styles.product_table}>
				<thead>
					<tr>
						{!checkSettings("hide_model_number") && (
							<th><Translated section="Project Summary" label="summary_table_model" /></th>
						)}
						<th><Translated section="Project Summary" label="summary_table_sku" /></th>
						<th><Translated section="Project Summary" label="summary_table_qty" /></th>
						<th><Translated section="Project Summary" label="summary_table_price" /></th>
					</tr>
				</thead>
				<tbody>
					{products.map(item => {
						let price;
						if (item.manual_price) price = item.manual_price;
						else if (item.non_stock_price) price = item.non_stock_price;
						else price = item.price;
						price = parseFloat(price) ? "$" + parseFloat(price).toFixed(2) : "$0.00";

						return (
							<tr>
								{!checkSettings("hide_model_number") && (
									<td>{item.model ? item.model : item.non_stock_model}</td>
								)}
								<td>
									{item.sku 
										? item.sku 
										: <Translated section="Project Summary" label="non_stock_label" />
									}
								</td>
								<td>{item.quantity}</td>
								<td>{price}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	renderSummary = state => {
		let client_fields = [
			[translator("Project Summary", "client_fname"), state.client.fname], 
			[translator("Project Summary", "client_lname"), state.client.lname], 
			[translator("Project Summary", "client_address"), state.client.address], 
			[translator("Project Summary", "client_city"), state.client.city], 
			[translator("Project Summary", "client_province"), state.client.province], 
			[translator("Project Summary", "client_postal"), state.client.postal, "break"], 
			[translator("Project Summary", "client_email"), state.client.email], 
			[translator("Project Summary", "client_day_phone"), state.client.phone_day], 
			[translator("Project Summary", "client_mobile_phone"), state.client.phone_mobile]
		];
		let project_fields = [
			[translator("Project Summary", "project_name"), state.project.title], 
			[translator("Project Summary", "project_warehouse"), state.project.warehouse], 
			[translator("Project Summary", "project_agent"), state.project.acting_agent ? translator("Misc", "yes_btn") : translator("Misc", "no_btn")], 
			[translator("Project Summary", "project_account"), state.project.account_name], 
			[translator("Project Summary", "project_ship_to"), state.project.ship_to, "break"], 
			[translator("Project Summary", "project_address"), state.project.address], 
			[translator("Project Summary", "project_city"), state.project.city], 
			[translator("Project Summary", "project_province"), state.project.province], 
			[translator("Project Summary", "project_postal"), state.project.postal, "break"]
		];
		let quote_fields = [
			[translator("Project Summary", "summary_order_number"), state.quote.order_number], 
			[translator("Project Summary", "summary_date"), this.formatDate(state.quote.order_date)], 
			[translator("Project Summary", "summary_message"), state.quote.summary]
		];
		let sections = [
			[translator("Project Summary", "client_label"), client_fields], 
			[translator("Project Summary", "project_label"), project_fields], 
			[translator("Project Summary", "quote_label"), quote_fields]
		];
		return (
			<div>
				<div className={styles.cards}>
					{sections.map((section, index) => (
						<div className={styles.card + " card"} key={index}>
							<h2 className={styles.card__title}>{section[0]}</h2>
							{section[1].map((field, i) => (
								<React.Fragment key={i}>
									<div className={styles.card__field}>
										<div className={styles.card__field__label}>{field[0]}</div>
										<div className={styles.card__field__value}>{field[1]}</div>
									</div>
									{field.length > 2 ? <br /> : ""}
								</React.Fragment>
							))}
							{index === 2 ? this.renderProductTable(state.products) : ""}
						</div>
					))}
				</div>
			</div>
		);
	};

	renderError = message => {
		return (
			<div class="card error-wrapper">
				<div class="error-message">{message}</div>
			</div>
		);
	};

	renderButtons = () => {
		return (
			<div className={styles.button_wrapper}>
				<button class="navbar-toggler toggler-example" type="button" data-toggle="collapse" data-target="#project-summary-buttons" aria-controls="project-summary-buttons" aria-expanded="false" aria-label="Toggle navigation">
					<span class="dark-blue-text project-quote-hamburger-icon">
						<i class="fas fa-bars fa-1x" />
					</span>
				</button>
				<div class="collapse navbar-collapse" id="project-summary-buttons">
					<ul class="navbar-nav mr-auto project-quote-list">
						<li class="nav-item">
							<DialogEmailQuote></DialogEmailQuote>
						</li>
						<li class="nav-item">
							<DialogEmailSpecList></DialogEmailSpecList>
						</li>
						<li class="nav-item">
							<PrintForm></PrintForm>
						</li>
						<li class="nav-item">
							<DialogEmailPictureBook></DialogEmailPictureBook>
						</li>
					</ul>
				</div>
			</div>
		);
	};

	render() {
		let state = this.state;
		if (state.redirect) return <Redirect to={state.redirect} />;
		return (
			<div className={styles.project_summary}>
				<div className={styles.header_wrapper}>
					<h1 className={styles.page_title}><Translated section="Project Summary" label="page_title" /></h1>
					{state.loaded && !state.error ? this.renderButtons() : ""}
				</div>
				{state.loaded && state.error ? this.renderError(state.error) : ""}
				{state.loaded && !state.error ? this.renderSummary(state) : ""}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = dispatch => {
	return {
		saveProjectId: projectId =>
			dispatch({
				type: actionTypes.SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT,
				projectId: projectId
			})
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProjectSummary);
